import React, { Component } from 'react';
import QuizDetails from './QuizDetails/QuizDetails';
import ProgressBarThin from './ProgressBar/ProgressBarThin/ProgressBarThin';
import ProgressBarThick from './ProgressBar/ProgressBarThick/ProgressBarThick';
import DeviceArea from './DeviceArea/DeviceArea';
import { CSSTransition } from 'react-transition-group';

import firebase from '../../firebase';
import * as routes from '../../constants/routes';
import {history} from "../../history";

import quizData from '../../data/quiz';
import logo from '../../img/logo.svg';
import './Quiz.css';
import utility from "../../utility/utility";


class Quiz extends Component {
    state = {
        step: 0,
        progress: 0,
        questionsAmount: 0,
        answers: [], 
        name: '',
        email: '',
        in: true,
        allowClicksPerQuizStep: true,
        btnLoading: false,
        reportError: false
    };

    componentWillMount = () => {
        let amount = 0;
        quizData.forEach((item) => {
            if (item.questions) {
                amount +=1;
            }
        });

        if (amount > 0) {
            this.setState({questionsAmount: amount});
        }
    };

    getDataFromForm = (name, email) => {
        this.setState({
            name,
            email
        });
    };

    getDataFormPass = (password) => {
        this.setState({
            password
        });
    };

    calculateYogaType = () => {
        const {answers} = this.state;
        let typesData = {
            A: {
                name: 'vata',
                count: 0,
                percentage: 0
            },
            B: {
                name: 'pitta',
                count: 0,
                percentage: 0
            },
            C: {
                name: 'kapha',
                count: 0,
                percentage: 0
            }
        };

        let totalAnsweredQuestions = 0;

        answers.forEach((answer) => {
            if (typesData[answer]) {
                typesData[answer].count += 1;
                totalAnsweredQuestions += 1;
            }
        });

        let typesDataArray = Object.values(typesData);
        typesDataArray.forEach((item) => {
            item.percentage = Math.round(item.count / totalAnsweredQuestions * 100);
        });

        typesDataArray.sort(function(a, b) {
            return b.percentage - a.percentage ;
        });

        let yogaType = 'unknown';
        let [max, middle, min] = typesDataArray;

        if (max.count > 0) {
            yogaType = max.name;

            if (max.percentage - middle.percentage < 5) {
                yogaType = `${max.name}-${middle.name}`;
            }
            if (max.percentage - min.percentage < 5) {
                yogaType = `${max.name}-${middle.name}-${min.name}`;
            }
        }

        this.setState({
            yogaType: yogaType,
            vata: typesData.A.percentage,
            pitta: typesData.B.percentage,
            kapha: typesData.C.percentage
        });
    };

    nextStep = (answerType) => {
        const {step, progress, questionsAmount} = this.state;

        if (this.state.allowClicksPerQuizStep) {
            if (quizData[step].questions) {
                this.setState((prevState) => {
                    return {
                        progress: prevState.progress + 1,
                        answers: [...prevState.answers, answerType]
                    }
                });
            }
    
            if (step < quizData.length - 1) {
                this.setState((prevState) => {
                    return {
                        in: !this.state.in,
                        step: prevState.step + 1,
                        allowClicksPerQuizStep: false
                    }
                })
            }
        }

        setTimeout(() => {
            this.setState((prevState) => {
                return {
                    allowClicksPerQuizStep: true
                }
            })
        }, 650);

        if (progress === questionsAmount) {
            this.calculateYogaType();
        }
    };

    sendRequest = () => {

        const {yogaType, email, name, password, vata, pitta, kapha} = this.state;

        this.setState({
            btnLoading: true
        });

        // create user in firebase
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .then((authUser) => {
                // get the current userID
                const currentUser = firebase.auth().currentUser;

                if(currentUser){

                    const userName = utility.toTitleCase(name);

                    // set the user data on register
                    firebase.database().ref('users/' + currentUser.uid).set({
                        name: userName,
                        email: email
                    })
                    .then(()=>{
                        // set the quiz report type
                        firebase.database().ref('user_reports/' + currentUser.uid).set({
                            user_id: currentUser.uid,
                            user_name: userName,
                            email_address: email,
                            vpk_percentages: vata + '-' + pitta + '-' + kapha,
                            report_yoga_type: yogaType
                        })
                        .then(()=>{
                            // report generation success
                            this.setState({
                                reportError: false
                            });
                            history.push(routes.REPORT);
                        })
                        .catch((err)=>{
                            this.setState({
                                btnLoading: false,
                                reportError: true
                            });
                            console.log(err);
                        });
                    })
                    .catch((err)=>{
                        this.setState({
                            btnLoading: false,
                            reportError: true
                        });
                        console.log(err);
                    });
                } else {
                    // unable to create user
                    this.setState({
                        btnLoading: false,
                        reportError: true
                    });
                    console.log('Unable to create new user in databae!');
                }

            })
            .catch(error => {
                this.setState({
                    btnLoading: false,
                    reportError: true
                });
                console.log(error);
            });
    };

    render() {
        const {name, step, progress, questionsAmount, answers, btnLoading, reportError} = this.state;
        
        return (
            <div className="quiz">
                <div className="quiz__left-side">
                    <div className="quiz__progress-top">
                        <ProgressBarThick currentAnswer={progress} totalAnswers={questionsAmount}/>
                    </div>
                    <div className="quiz__area">
                        <CSSTransition
                            timeout={600}
                            classNames="fade"
                            in={this.state.in}
                        >
                            <QuizDetails
                                key={step}
                                data={quizData[step]}
                                answers={answers}
                                toNextStep={this.nextStep}
                                sendRequest={this.sendRequest}
                                dataFromForm={this.getDataFromForm}
                                dataFormPass={this.getDataFormPass}
                                dataUserName={name}
                                btnLoading={btnLoading}
                                reportError={reportError}
                            />
                        </CSSTransition>
                    </div>
                </div>
                <div className="quiz__right-side">
                    <img src={logo} alt="" className="quiz__right-side-logo"/> 
                    <DeviceArea currentAnswer={progress} totalAnswers={questionsAmount}/>
                   <div className="quiz__answers-area">
                        <ProgressBarThin currentAnswer={progress} totalAnswers={questionsAmount}/>
                   </div>
                </div>
            </div>
        );
    }
}

export default Quiz;


// WEBPACK FOOTER //
// ./src/components/Quiz/Quiz.js